import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

/**
 * Componente che mostra un banner quando l'app va offline
 */
export function PWAOfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Mostra brevemente il banner "Connesso"
      setShowBanner(true);
      setTimeout(() => setShowBanner(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Mostra il banner se siamo offline all'avvio
    if (!navigator.onLine) {
      setShowBanner(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] pointer-events-none">
      <div
        className={`
          mx-auto mt-4 max-w-md px-4 pointer-events-auto
          transition-all duration-300 ease-in-out
          ${showBanner ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}
        `}
      >
        <div
          className={`
            rounded-lg shadow-lg px-4 py-3 flex items-center gap-3
            ${
              isOnline
                ? 'bg-green-500 text-white'
                : 'bg-yellow-500 dark:bg-yellow-600 text-white'
            }
          `}
        >
          {isOnline ? (
            <Wifi className="w-5 h-5 flex-shrink-0" />
          ) : (
            <WifiOff className="w-5 h-5 flex-shrink-0 animate-pulse" />
          )}
          
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm">
              {isOnline ? 'Connesso' : 'Modalità Offline'}
            </p>
            <p className="text-xs opacity-90">
              {isOnline
                ? 'Connessione ripristinata'
                : 'Alcune funzionalità potrebbero non essere disponibili'}
            </p>
          </div>

          {!isOnline && (
            <button
              onClick={() => setShowBanner(false)}
              className="flex-shrink-0 text-white hover:text-gray-200 text-xl font-bold"
              aria-label="Chiudi"
            >
              ×
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default PWAOfflineIndicator;
